import { GoogleMap, useGoogleMap } from "@react-google-maps/api";
import React, { useState, useRef } from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";

function Places(props: any) {
  return (
    <GooglePlacesAutocomplete
      apiKey="AIzaSyDEbmqlzlkU3mErAG-PPdPEbTrv6opHmag"
      selectProps={{
        styles: {
          control: (provided: any) => ({
            ...provided,
            color: "black",
          }),
          input: (provided: any) => ({
            ...provided,
            color: "black",
          }),
          option: (provided: any) => ({
            ...provided,
            color: "black",
          }),
          singleValue: (provided: any) => ({
            ...provided,
            color: "black",
          }),
        },
        placeholder: "Search a location",
        onChange: (value: any) => {
          props.setPlacesValue(value);
        },
      }}
    />
  );
}

export default Places;
